module.exports = __webpack_public_path__ + "static/img/xuqiudating.65ecc0db.png";